<template>
  <div class="messagebox">
    <transition name="fade">
      <div class="popup" v-show="value">
        <div class="content-box">
          <div class="poptitle">
            <h1>活动详情</h1>
          </div>
          <div class="popcontent" v-html="activityBannerDesc.desc">
            {{ activityBannerDesc.desc }}
          </div>
          <div class="closeIcon" @click="modifyingdata">
            <img src="../../assets/images/icon_close.png" alt />
          </div>
        </div>
        <div class="mask" @click="modifyingdata"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "messagebox",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    modifyingdata() {
      this.$emit("input", false)
    }
    // subscribe() {
    //   window.OpenApp(
    //     {
    //       id: "南方号id",
    //       shareType: "nfhSub",
    //       isnfh: true
    //     },
    //     process.env.VUE_APP_RUN_ENV
    //   )
    // }
  },
  computed: {
    ...mapGetters({
      activityBannerDesc: "activityInfo/activityBannerDesc"
    })
  }
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.messagebox {
  z-index: 99999;
  .popup {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .content-box {
      position: relative;
      z-index: 99999;
      width: 6.4rem;
      background: #ffffff;
      padding: 0.4rem 0.3rem 0;
      border-radius: 0.2rem;
      overflow: auto;
      .poptitle {
        h1 {
          width: 100%;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 0.36rem;
          color: #333333;
          letter-spacing: 0;
          font-weight: normal;
        }
      }
      .popcontent {
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        color: #666666;
        letter-spacing: 0;
        max-height: 7.14rem;
        overflow: auto;
        margin: 0;
        margin-top: 0.3rem;
        padding: 0 0.2rem;
        box-sizing: border-box;
      }
      .popbtn {
        width: 5.4rem;
        height: 0.88rem;
        font-family: PingFangSC-Semibold;
        font-size: 0.3rem;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.88rem;
        border-radius: 0.44rem;
        cursor: pointer;
        background: #f64e45;
      }
      .closeIcon {
        width: 0.8rem;
        height: 0.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        img {
          width: 0.2rem;
          height: 0.2rem;
        }
      }
    }
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 6;
    }
  }
}
</style>
